import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../assets/images/Footer.png";
import PayAttitudeImage from "../assets/images/payattitude.png";
import CardContext from "../store/card-context";
import useHttp from "../hooks/use-http";

const PayAttitudeOtp = () => {
  const [shuffledArray, setShuffledArray] = useState([]);
  //const [timer, setTimer] = useState("05:00");
  const INITIAL_TIME = 300; // 5 mins in seconds

  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);
  const [arrayPart1, setArrayPart1] = useState([]);
  const [arrayPart2, setArrayPart2] = useState([]);
  const [otpValue, setOtpValue] = useState("");
  const [transactionDetails, setTransactionDetails] = useState({});
  const { sendRequest: getTransaction } = useHttp();
  const { isLoading, sendRequest: postOtpTransaction } = useHttp();
  const { cardDetails, token } = useContext(CardContext);
  const navigate = useNavigate();
  const { sendRequest } = useHttp();

  const { scheme } = cardDetails;

  const { id } = useParams();

  useEffect(() => {
    if (timeLeft <= 0) {
      navigate(`/card/${id}/payment-confirmation/${id}`);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, id, navigate]);

  const timer = `${String(Math.floor(timeLeft / 60)).padStart(2, "0")}:${String(
    timeLeft % 60
  ).padStart(2, "0")}`;

  // const startTimer = () => {
  //   const [minutes, seconds] = timer.split(":").map(Number);
  //   let totalSeconds = minutes * 60 + seconds;

  //   const timerInterval = setInterval(() => {
  //     totalSeconds--;

  //     const newMinutes = Math.floor(totalSeconds / 60);
  //     const newSeconds = totalSeconds % 60;

  //     setTimer(
  //       `${newMinutes.toString().padStart(2, "0")}:${newSeconds
  //         .toString()
  //         .padStart(2, "0")}`
  //     );

  //     if (totalSeconds === 0) {
  //       navigate(`/card/${id}/payment-confirmation/${id}`);
  //       // setDisableButton(true);
  //       clearInterval(timerInterval);
  //     }
  //   }, 1000);

  //   return () => clearInterval(timerInterval);
  // };

  // useEffect(() => {
  //   startTimer();
  // }, []);

  const fetchTransactionInfo = (data) => {
    setTransactionDetails(data);
  };

  const fetchTransaction = useCallback(() => {
    getTransaction(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/${id}`,
        headers: { "Content-Type": "application/json" },
      },
      fetchTransactionInfo
    );
  }, [getTransaction, id]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchTransaction();
    };
    fetchData();
  }, [fetchTransaction]);

  const confirmTransaction = (data) => {
    if (data?.success === true) {
      navigate(`/card/${id}/payment-confirmation/${id}`);
    } else {
      navigate(`/card/${id}/payment-confirmation/${id}`);
    }
  };

  const processOtpTransaction = () => {
    postOtpTransaction(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/postOtpDetail/${id}`,
        method: "POST",
        body: { ...cardDetails, Otp: otpValue, Token: token },
        headers: { "Content-Type": "application/json" },
      },
      confirmTransaction
    );
  };

  const shuffleArray = useCallback((array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }, []);

  useEffect(() => {
    // Create an array of numbers from 0 to 9
    const originalArray = Array.from({ length: 10 }, (_, index) => index);

    // Shuffle the array
    shuffleArray(originalArray);

    // Split the shuffled array into two arrays with lengths of 6 and 4
    const part1 = originalArray.slice(0, 6);
    const part2 = originalArray.slice(6);

    setShuffledArray(originalArray);
    setArrayPart1(part1);
    setArrayPart2(part2);
  }, [shuffleArray]); // Run this effect only once on component mount

  const handleButtonClick = (num) => {
    // Append the clicked number to the current OTP value
    setOtpValue((prevValue) => prevValue + num);
  };

  const handleDeleteButtonClick = () => {
    // Remove the last digit from the current OTP value
    setOtpValue((prevValue) => prevValue.slice(0, -1));
  };

  const clearInput = () => {
    setOtpValue(""); // Reset otpValue to an empty string
  };

  const goBackHandler = () => {
    navigate(-1);
  };
  const handleGoBackClick = () => {
    goBackHandler();
  };

  const confirmCancel = (data) => {
    window.location.href = data?.data?.returnUrl;
  };

  const cancelTransaction = () => {
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/cancelTransaction/${id}`,
        headers: { "Content-Type": "application/json" },
      },
      confirmCancel
    );
  };

  return (
    <div className="w-full max-w-[560px] mx-auto px-4 py-2 font-sans">
      {/* Top Navigation & Cancel Actions */}
      <div className="flex justify-between items-center mb-6">
        <button
          className="flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors"
          onClick={handleGoBackClick}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 25"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <span>Go Back</span>
        </button>
        <button
          onClick={cancelTransaction}
          className="p-2 border border-slate-200 hover:border-red-100 hover:bg-red-50 hover:text-red-600 rounded-full text-slate-400 transition-all flex items-center justify-center"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      {isLoading && !transactionDetails?.data ? (
        <div className="flex justify-center py-12">
          <p className="text-slate-500 text-sm">Loading details...</p>
        </div>
      ) : (
        <div className="space-y-6">
          {/* Merchant Info Summary */}
          <div className="flex justify-between items-start border-b border-slate-100 pb-5">
            <div>
              <h3 className="text-lg font-bold text-slate-800 leading-tight">
                {transactionDetails?.data?.merchantName}
              </h3>
              <p className="text-xs text-slate-500 mt-1">
                {transactionDetails?.data?.email}
              </p>
            </div>
            <div className="text-right">
              <span className="text-xs text-slate-400 font-semibold block uppercase tracking-wide">
                Amount to Pay
              </span>
              <span className="text-xl font-extrabold text-[#00aeef] block mt-0.5">
                {transactionDetails?.data?.currency || "NGN"}{" "}
                {transactionDetails?.data?.amount?.toLocaleString() || "0"}
              </span>
              <span className="text-[10px] text-slate-400 font-medium block mt-0.5">
                (Fee: {transactionDetails?.data?.currency || "NGN"} {transactionDetails?.data?.fee || "0"})
              </span>
            </div>
          </div>

          {/* Collapsible/Sleek Transaction Detail Box */}
          <div className="w-full max-w-[460px] mx-auto rounded-2xl border border-dashed border-slate-200 bg-slate-50/50 p-4 space-y-3">
            <div className="flex justify-between items-center text-xs">
              <span className="text-slate-400 font-semibold">Amount</span>
              <span className="text-slate-700 font-bold">
                {transactionDetails?.data?.currency || "NGN"} {transactionDetails?.data?.amount?.toLocaleString() || "0"}
              </span>
            </div>
            <div className="flex justify-between items-center text-xs">
              <span className="text-slate-400 font-semibold">Processing Fee</span>
              <span className="text-slate-700 font-bold">
                {transactionDetails?.data?.currency || "NGN"} {transactionDetails?.data?.fee?.toLocaleString() || "0"}
              </span>
            </div>
            <div className="flex justify-between items-center text-xs">
              <span className="text-slate-400 font-semibold">Transaction ID</span>
              <span className="text-slate-600 font-mono select-all">{id}</span>
            </div>
            {transactionDetails?.data?.description && (
              <div className="pt-2 border-t border-slate-200/60 text-xs">
                <span className="text-slate-400 font-semibold block mb-1">Description</span>
                <span className="text-slate-600 leading-relaxed">
                  {transactionDetails?.data?.description}
                </span>
              </div>
            )}
          </div>

          {/* OTP Enter Form label & Input */}
          <div className="text-center">
            <label
              className="text-slate-700 text-base font-bold"
              htmlFor="otp"
            >
              Enter OTP
            </label>
            <p className="text-xs text-slate-500 mt-1">
              Please enter the PayAttitude authorization OTP.
            </p>
          </div>

          <div className="w-full max-w-[460px] mx-auto relative flex items-center gap-3 border border-slate-200 rounded-xl px-4 py-3 bg-slate-50/50 focus-within:border-[#00aeef] focus-within:bg-white transition-all">
            <img
              src={PayAttitudeImage}
              alt="PayAttitude"
              className="h-6 w-auto object-contain"
            />
            <input
              value={otpValue}
              id="otp"
              placeholder="••••"
              type="password"
              className="w-full bg-transparent focus:outline-none text-xl font-bold tracking-widest text-slate-700 placeholder:text-slate-300 p-0"
              readOnly
            />
            <div className="text-slate-400">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"></path>
              </svg>
            </div>
          </div>

          {/* Keys Pad grid */}
          <div className="w-full max-w-[460px] mx-auto">
            <div className="grid grid-cols-6 gap-2">
              {arrayPart1.map((num, index) => (
                <button
                  key={index}
                  onClick={() => handleButtonClick(num)}
                  className="h-12 flex items-center justify-center bg-slate-50 hover:bg-slate-100 active:scale-95 text-slate-800 font-bold text-base rounded-xl transition-all border border-slate-200/60 shadow-sm"
                >
                  {num}
                </button>
              ))}
            </div>
            <div className="grid grid-cols-6 gap-2 mt-2">
              <button
                className="h-12 flex items-center justify-center bg-slate-800 hover:bg-slate-900 active:scale-95 text-white rounded-xl transition-all shadow-sm"
                onClick={handleDeleteButtonClick}
              >
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 22 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.4743 12.151L13.3081 9.35098M13.3081 9.35098L16.1419 6.55098M13.3081 9.35098L16.1419 12.151M13.3081 9.35098L10.4743 6.55098M8.04547 1.75098H17.7614C19.55 1.75098 21 3.18367 21 4.95098C21 7.61764 21 10.2843 21 12.951C21 14.7183 19.55 16.151 17.7614 16.151H8.04547C7.46528 16.151 6.75769 15.831 6.42616 15.431L2.00441 11.2676C0.6652 10.0066 0.665197 7.89535 2.0044 6.63439L6.17832 2.70433C6.34309 2.54919 6.48254 2.36737 6.65527 2.22094C7.02483 1.90763 7.57673 1.75098 8.04547 1.75098Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
              {arrayPart2.map((num, index) => (
                <button
                  key={index}
                  onClick={() => handleButtonClick(num)}
                  className="h-12 flex items-center justify-center bg-slate-50 hover:bg-slate-100 active:scale-95 text-slate-800 font-bold text-base rounded-xl transition-all border border-slate-200/60 shadow-sm"
                >
                  {num}
                </button>
              ))}
              <button
                className="h-12 flex items-center justify-center bg-slate-800 hover:bg-slate-900 active:scale-95 text-white font-semibold text-xs rounded-xl transition-all shadow-sm"
                onClick={clearInput}
              >
                Clear
              </button>
            </div>
          </div>

          {/* OTP Resend timer info */}
          <div className="text-center pt-2">
            <span className="text-sm text-slate-500 font-semibold">
              OTP expires in <span className="text-red-500 font-mono font-bold bg-red-50 border border-red-100 px-2 py-0.5 rounded">{timer}</span>
            </span>
          </div>

          {/* Submit Button */}
          <div className="flex justify-center pt-4">
            <button
              className="w-full max-w-[460px] h-[54px] bg-[#00aeef] hover:bg-[#0096ce] active:scale-[0.99] text-white rounded-lg font-bold text-base transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md shadow-[#00aeef]/10"
              onClick={processOtpTransaction}
              disabled={isLoading || otpValue.length === 0}
            >
              {isLoading ? (
                <span>Processing...</span>
              ) : (
                `Pay ${transactionDetails?.data?.currency || "NGN"} ${(
                  (transactionDetails?.data?.amount || 0) + (transactionDetails?.data?.fee || 0)
                ).toLocaleString()}`
              )}
            </button>
          </div>

          {/* Powered by Payloft footer branding */}
          {!localStorage.getItem("AppName") && (
            <div className="flex justify-center mt-8 pb-4">
              <img src={Footer} alt="Payloft" className="w-[180px] opacity-40 hover:opacity-60 transition-opacity" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PayAttitudeOtp;
